import { CenterBigButtons, PageContainter } from "../SubPageLayout";
import { BigButtons } from "./BigButtons";
import { defineButton } from "./DynamicBigButton";

export function BigButtonsPage(props: {
	buttons: ReturnType<typeof defineButton>[];
	prefix?: React.ReactNode;
	suffix?: React.ReactNode;
}) {
	return (
		<PageContainter>
			<CenterBigButtons>
				{props.prefix}
				<div className="mt-[2h]">
					<BigButtons
						buttons={props.buttons}
					/>
				</div>
				{props.suffix}	
			</CenterBigButtons>
		</PageContainter>
	);
}
